import type { ComponentType, SVGProps } from 'react';
import { EmptyState } from '@immo/ui-kit';
import { PlugIcon, SearchIcon, WarningTriangleIcon } from '@/components/layout/icons';
import { useTranslations } from '@/i18n/use-translations';
import type { FleetBoardPageErrorCode } from '@/lib/fleet/board-poll';

const ICONS: Record<FleetBoardPageErrorCode, ComponentType<SVGProps<SVGSVGElement>>> = {
  'fleet.queue.team-not-found': SearchIcon,
  'fleet.queue.tracker-unreachable': WarningTriangleIcon,
  'fleet.queue.tracker-not-configured': PlugIcon,
};

/** Renders from the code only, never the wire message (ADR 0014). */
export function BoardErrorState({ code }: { readonly code: FleetBoardPageErrorCode }) {
  const tErrors = useTranslations('errors');
  const Icon = ICONS[code];

  return (
    <div className="flex h-full min-h-0 items-center justify-center">
      <EmptyState title={tErrors(code)} icon={<Icon className="h-16 w-16" aria-hidden />} />
    </div>
  );
}
